// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"706":"705baa66","892":"392a5e00"}[chunkId] + ".chunk.css";
};